import {
  Alert,
  AlertDescription,
  AlertIcon,
  FormControl,
  FormLabel,
  HStack,
  Text,
  Textarea,
  VStack
} from '@chakra-ui/react'
import { FC } from 'react'

// Limite aceito pela API para a justificativa fora do cronograma
export const JUSTIFICATIVA_FORA_CRONOGRAMA_MAX = 1000

interface Props {
  justificativa: string
  onJustificativaChange: (value: string) => void
}

// Passo 2 do Criar Pedido quando o Comprador não utiliza o Cronograma:
// justificativa única obrigatória; a aprovação segue as mesmas regras de
// tolerância e alçada do fluxo com cronograma
const ForaCronogramaReview: FC<Props> = ({
  justificativa,
  onJustificativaChange
}) => (
  <VStack spacing={5} align="stretch">
    <Alert status="warning" borderRadius="md" alignItems="flex-start">
      <AlertIcon />
      <AlertDescription fontSize="sm">
        As compras devem respeitar as datas programadas no Cronograma de
        Compras. Como o cronograma não está sendo utilizado, informe a
        justificativa. O pedido só vai para aprovação se algum item exigir
        (quantidade acima da tolerância ou item sem recomendação).
      </AlertDescription>
    </Alert>

    <JustificativaForaCronogramaField
      id="justificativa-fora-cronograma-pedido"
      label="Justificativa para não utilizar o Cronograma de Compras"
      value={justificativa}
      onChange={onJustificativaChange}
      rows={3}
    />
  </VStack>
)

interface FieldProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  rows?: number
  placeholder?: string
  autoFocus?: boolean
}

// Campo obrigatório com contador (usado no pop-up do filtro e no Criar Pedido)
export const JustificativaForaCronogramaField: FC<FieldProps> = ({
  id,
  label,
  value,
  onChange,
  rows = 3,
  placeholder = 'Informe o motivo',
  autoFocus
}) => (
  <FormControl isRequired>
    <FormLabel fontWeight="bold">{label}</FormLabel>
    <Textarea
      id={id}
      value={value}
      onChange={e =>
        onChange(e.target.value.slice(0, JUSTIFICATIVA_FORA_CRONOGRAMA_MAX))
      }
      maxLength={JUSTIFICATIVA_FORA_CRONOGRAMA_MAX}
      placeholder={placeholder}
      borderColor="gray.400"
      _hover={{ borderColor: 'gray.600' }}
      rows={rows}
      autoFocus={autoFocus}
    />
    <HStack justify="space-between" mt={1}>
      <Text fontSize="xs" color="gray.500">
        Registrada no pedido e visível ao aprovador.
      </Text>
      <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
        {value.length}/{JUSTIFICATIVA_FORA_CRONOGRAMA_MAX}
      </Text>
    </HStack>
  </FormControl>
)

export default ForaCronogramaReview
